import i18n from '@/i18n'
import { thingService } from "../../../../../services/thing.service"

export default {
    name: 'ThingDataTabComponent',
    components: {
    },
    model: {
        prop: 'model',
        event: 'change'
    },
    props: {
        model: {
            type: Object,
            required: true
        },
        validationRules: {
            type: Object,
            required: true
        },
        validForm: {
            type: Boolean,
            required: true
        },
        resetFormValidation: {
            type: Boolean,
            required: true
        }
    },
    data: () => ({
        // model para el formulario
        // identificator actual
        actualIdentificator: null,
        // errores de identificador
        identificatorCodeError: [],
        isValidForm: false,
    }),
    computed: {
    },
    created () {
        this.actualIdentificator = this.model.identificator
    },
    beforeDestroy() {
    },
    mounted () {
    },
    methods: {
        /**
         * Mensaje de error cuando el codigo identificator del equipo está duplicado
         */
        async identificatorCodeDuplicatedMethod() {
            if (this.model.identificator?.trim() === this.actualIdentificator?.trim()) {
                this.identificatorCodeError = []
                return true
            }
            const response = await thingService.validateIdentificatorCode(this.model.identificator?.trim())
            if (response) {
                this.identificatorCodeError.push(`${i18n.t('equipment.error.duplicate')}`)
                return false
            } else {
                this.identificatorCodeError = []
                return true
            }

        },
    },
    watch: {
        /**
         * Para restablecer las validaciones del formulario
         * @param {*} newVal
         */
        resetFormValidation(newVal) {
            if (newVal && this.$refs.thingDataTabForm) {
                this.$refs.thingDataTabForm.resetValidation()
            }
        },
        isValidForm(newVal, oldVal){
            if(newVal !== oldVal){
                this.$emit('update:validForm', newVal)
            }
        },
    }
}
